import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    appVersions: [],
  }),

  mutations: {
    setAppVersions(state, appVersions) {
      Vue.set(state, "appVersions", appVersions);
    },
  },

  actions: {
    createAppVersion: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/app-versions/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadAppVersion: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/app-versions/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    loadSelectedAppVersionHistory: (context, appVersion) => {
      return axios.get(context.getters.getMcServiceUrl + "/app-versions/history/" + appVersion.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteAppVersion: (context, appVersion) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/app-versions/entity/" + appVersion.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          appVersion.intents = intents;
          appVersion.intentId = response.data.id;
          return appVersion;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftAppVersion: (context, appVersion) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/app-versions/draft/" + appVersion.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishAppVersion: (context, appVersion) => {
      return axios.get(context.getters.getMcServiceUrl + "/app-versions/publish/" + appVersion.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectAppVersion: (context, appVersion) => {
      return axios.get(context.getters.getMcServiceUrl + "/app-versions/reject/" + appVersion.intentId).then((response) => {
        helper.recallOrRejectEntity(appVersion, "appVersion");
        return response.data;
      });
    },

    sendToApprovalAppVersions: (context, appVersion) => {
      return axios.get(context.getters.getMcServiceUrl + "/app-versions/sendToApproval/" + appVersion.intentId).then((response) => {
        if (appVersion.intents[0].type === "CREATE_APP_VERSION") {
          appVersion.intents[0].status = "WAITING_APPROVAL";
        } else if (appVersion.intents[0].type === "UPDATE_APP_VERSION") {
          appVersion.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallAppVersion: (context, appVersion) => {
      return axios.get(context.getters.getMcServiceUrl + "/app-versions/recall/" + appVersion.intentId).then((response) => {
        helper.recallOrRejectEntity(appVersion, "appVersion");
        return response.data;
      });
    },

    cancelAppVersion: (context, appVersion) => {
      return axios.get(context.getters.getMcServiceUrl + "/app-versions/cancel/" + appVersion.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getAppVersions: (state) => {
      return state.appVersions;
    },
    getPublishedAppVersions: (state) => {
      return state.appVersions.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
